// Copyright (c) 2017 Deere & Company

import actions from '../../actions-list';

export const resetAuditStatus = () => ({
    type: actions.RESET_AUDIT_STATUS_REPORT
});



// WEBPACK FOOTER //
// ./src/reports/audit-status/action-creators/reset-audit-status.js